import type { GameDestinationContext } from "@softmax/web-addresses";

export type SiteSearchCoworldContext = {
  // APIs use the raw corpus name; presentation rules use its normalized slug.
  readonly name: string;
  readonly corpusSlug: string;
  readonly route: GameDestinationContext;
  readonly hasWiki: boolean;
};
export const maxQueryChars = 200;

// Code-point slicing cannot split an emoji into an invalid URL surrogate.
export function clampQuery(raw: string): string {
  return [...raw.trim()].slice(0, maxQueryChars).join("");
}

export function platformShortcutHint({
  nav = typeof navigator === "undefined" ? {} : navigator,
}: {
  readonly nav?:
    | {
        readonly userAgentData?: {
          readonly platform?: string;
        };
        readonly platform?: string;
      }
    | undefined;
}): string {
  const platform = nav.userAgentData?.platform ?? nav.platform ?? "";
  return /mac|iphone|ipad|ipod/i.test(platform) ? "⌘K" : "Ctrl K";
}

export function isSearchActivationKey(event: KeyboardEvent): boolean {
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k")
    return true;

  if (event.key !== "/") return false;

  const target = event.target instanceof HTMLElement ? event.target : null;
  return (
    !target?.isContentEditable &&
    !(target && /^(input|textarea|select)$/i.test(target.tagName))
  );
}
